import React from 'react';
import CardButton from '../CardButton/CardButton';
import './TaskSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import { view_all_tasks} from '../../../../../cosmosTracking/cosmosEvents'
import taskAnimation from '../../../Resources/Slides/indipendence/task-win.json';
import coinAnimation from '../../../Resources/Slides/indipendence/coin.json';
import Lottie from "react-lottie";

function TaskSlide(props) {
	const { data } = props;
	const taskAnimationLottie = {
		loop: true,
		autoplay: true,
		animationData: taskAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
	const coinAnimationLottie = {
		loop: true,
		autoplay: true,
		animationData: coinAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
	return (
		<div className="slideCard slideCardTask">
			<div className="cardHeader">
				<Lottie options={taskAnimationLottie} height={128}></Lottie>
			</div>
			<div className="cardContent">
				<div className="taskData">
					<div>
						<p>Get chance</p>
						<h4>to win cash prizes</h4>
						<h4>Worth ₹20,000/-</h4>
					</div>
					<Lottie options={coinAnimationLottie} width={80} height={80}></Lottie>
				</div>
				<CardButton text={'View All Tasks'}
							eventCallback={() => {cosmosTrackService(view_all_tasks);}}
							className={'btn-action'}
							deeplink={data?.deeplink}
				/>
			</div>
		</div>
	);
}

export default TaskSlide;
